import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { DNASelect, DNAText, DNABox, IndexPath } from '@alucio/lux-ui';
import { PromptType } from '@alucio/aws-beacon-amplify/src/models';
import { PROMPT_TYPE_CONFIG } from 'src/state/context/PromptValues/PromptValuesStateProvider';

const styles = StyleSheet.create({
  select: {
    minWidth: 200,
  },
});

interface PromptTypeSelectorProps {
  selectedType: PromptType;
  onTypeChange: (type: PromptType) => void;
  disabled?: boolean;
}

const PromptTypeSelector: React.FC<PromptTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
  disabled = false,
}) => {
  const availablePromptTypes = useMemo(
    () => Object.values(PromptType),
    [],
  );

  const resolvedSelectedType = availablePromptTypes.includes(selectedType)
    ? selectedType
    : availablePromptTypes[0];

  const handleSelectionChange = (indexPath: IndexPath | IndexPath[]) => {
    const index = Array.isArray(indexPath) ? indexPath[0]?.row : indexPath?.row;
    if (typeof index === 'number') {
      const selectedPromptType = availablePromptTypes[index];
      if (selectedPromptType) {
        onTypeChange(selectedPromptType);
      }
    }
  };

  const selectedIndex = resolvedSelectedType ? availablePromptTypes.indexOf(resolvedSelectedType) : -1;

  return (
    <DNABox appearance="col" spacing="md">
      <DNAText h4>Type</DNAText>
      <DNASelect
        style={styles.select}
        selectedIndex={selectedIndex >= 0 ? new DNASelect.Index(selectedIndex) : undefined}
        onSelect={handleSelectionChange}
        disabled={disabled}
        placeholder="Select type"
        value={resolvedSelectedType ? PROMPT_TYPE_CONFIG[resolvedSelectedType].displayName : undefined}
        testID="prompt-type-selector"
      >
        {availablePromptTypes.map((type) => (
          <DNASelect.Item
            key={type}
            title={PROMPT_TYPE_CONFIG[type].displayName}
            testID={`prompt-type-option-${type}`}
          />
        ))}
      </DNASelect>
    </DNABox>
  );
};

export default PromptTypeSelector;
